/**
 * At-bat result badge — replaces the old STATCAST pill in the PitchLog
 * header. Renders the just-finished at-bat's result text (e.g. "Single",
 * "Strikeout", "Sac Fly") with an accent outline. Hidden during in-
 * progress at-bats (selectCurrentAtBatResult returns null).
 */
import type { AtBatResult } from '../state/selectors';
import styles from './AtBatResultBadge.module.css';

interface AtBatResultBadgeProps {
  result: AtBatResult | null;
}

export default function AtBatResultBadge({ result }: AtBatResultBadgeProps): JSX.Element | null {
  if (!result) return null;
  return (
    <span
      className={styles.badge}
      data-testid="at-bat-result-badge"
      title={result.description ?? undefined}
    >
      {result.event}
    </span>
  );
}
